<ion-list>
  <ion-item-divider *ngIf="title" sticky>
    <ion-label class="ion-text-wrap title">
      <h2>{{ title }}</h2>
    </ion-label>
  </ion-item-divider>

  <app-journal-item
    *ngFor="let journalItem of journalItems"
    [item]="journalItem"
    [isNew]="isNew(journalItem)"
    [showUserName]="showUserName"
  ></app-journal-item>
</ion-list>
